import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const analyticsGISDealerMapRoutes = [
	{
		key: "analytics-gis-dealer-map",
		exact: true,
		path: `${APP_PREFIX_PATH}/analytics/dealer/map`,
		component: React.lazy(() => import("views/analytics-views/dashboards/sub-dashboards/internal/gis-dealer-map/pages/DealerMap")),
	},
];
